import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/canteen/inventory/remote-group",
        component: List,
        name: "inventory-remote-group",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-group/create",
        component: Create,
        name: "inventory-remote-group-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-group/:id/edit",
        component: Edit,
        name: "inventory-remote-group-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
